import Box from '@mui/material/Box'
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined'

import { BuyingOfElectricity } from './components/BuyingOfElectricity'
import { StepIcon } from './wizard-common'

export function WizardStep6({
    nextStep,
    goBack,
    estateId,
}: {
    nextStep: () => void
    goBack: () => void
    estateId: number
}) {

    return (
        <Box>
            <StepIcon icon={<ShoppingCartOutlinedIcon />} color={'#ffecdb'} />

            <BuyingOfElectricity estateId={estateId} goBack={goBack} nextStep={nextStep} />
        </Box>
    )
}
